
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-facebook",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.807 32V15.915H8.556v-5.476h3.251V7.188c0-4.449 1.883-7.187 7.187-7.187h4.449v5.476h-2.909c-2.053 0-2.225.856-2.225 2.225v2.738h4.963l-.514 5.476h-4.449v16.085h-6.502z"}})])
          )
        }
      }
    